// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".now[data-v-d421fce6]{width:120px;height:36px;background:#1D85F9;border-radius:2px;display:flex;padding-left:13px;align-items:center;font-size:14px;font-weight:400;color:#FFFFFF;line-height:36px;box-sizing:border-box}.now img[data-v-d421fce6]{width:14px;height:14px;margin-right:8px}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
